import { render, staticRenderFns } from "./DefectAct.vue?vue&type=template&id=6a2f3eea&scoped=true&"
import script from "./DefectAct.vue?vue&type=script&lang=js&"
export * from "./DefectAct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2f3eea",
  null
  
)

export default component.exports